export default {
  tabs: {
    profile: 'Perfil',
    branding: 'Marca',
    domain: 'Dominio',
    earning: 'Ganancias',
    feature_flags: 'Indicadores de funcionalidad',
    notification_channels: 'Canales de notificación',
    pricing: 'Precios',
    fees: 'Tarifas',
    payments: 'Pagos',
    billing: 'Facturación',
  },
  earning: {
    internal_notice: 'Ajustes exclusivos de FoodAmigos. No visibles para el partner.',
    read_only_notice: 'Solo lectura. Haz clic en Editar para cambiar algún valor.',
    editing_notice: 'Editando — los cambios afectan los cálculos reales de pagos.',
  },
  fees: {
    internal_notice:
      'Configuración exclusiva de FoodAmigos. No es visible para el partner y solo los superadministradores pueden abrir esta pestaña. Los cambios afectan lo que se cobra a los comensales y lo que gana la plataforma.',
    read_only_notice: 'Solo lectura. Haz clic en Editar para cambiar cualquier valor en esta pestaña.',
    editing_notice:
      'Editando — Guardar registra tanto la tarifa de servicio como las tasas de procesamiento. Las tasas se aplican desde el próximo cobro en adelante; las transacciones anteriores mantienen el margen registrado.',
  },
  profile: {
    read_only_notice: 'Solo lectura. Haz clic en Editar para cambiar algún valor.',
    editing_notice: 'Editando — el nombre visible lo ven los consumidores.',
    form: {
      name: {
        label: 'Nombre del partner',
        hint: 'El nombre legal o de la entidad. Se usa internamente y en los documentos de facturación.',
      },
      display_name: {
        label: 'Nombre visible para consumidores',
        hint: 'La etiqueta «Con tecnología de ___» que ven los clientes. Si se deja en blanco, se usa el nombre del partner.',
      },
      admin_email: {
        label: 'Correo del administrador',
        hint: 'La cuenta de administrador invitada. No se puede cambiar aquí — contacta con ingeniería para transferir la cuenta.',
      },
      invoicing_emails: {
        label: 'Correos de facturas',
        hint: 'Los recibos de las facturas emitidas a este socio se envían a cada una de estas direcciones. Déjelo vacío para usar el correo del administrador.',
        placeholder: 'Correo del administrador',
      },
      status: {
        label: 'Estado',
        hint: 'Los partners invitados se activan en su primer inicio de sesión — activar manualmente omite ese paso. Suspender desactiva todos los accesos del equipo del partner.',
      },
      region: {
        label: 'Región',
        hint: 'El país está fijo. Elija un estado cuando los restaurantes del socio sigan normas fiscales estatales — esto solo cambia los valores predeterminados del socio, no los restaurantes existentes.',
      },
      messenger_audience: {
        label: 'Chat de soporte',
        hint: 'Quién dentro de este partner tiene el chat de soporte de FoodAmigos. El personal de FoodAmigos siempre lo tiene. Los partners de marca blanca dan soporte a sus propios restaurantes, así que solo sus administradores lo tienen.',
        options: {
          everyone: 'Todos, restaurantes incluidos',
          partner_admins: 'Solo administradores del partner',
          nobody: 'Nadie',
        },
      },
      shop_domains: {
        label: 'Dominios de tienda',
        hint: 'Dominios raíz donde se sirven las tiendas de los restaurantes del socio. El dominio principal se usa para nuevas marcas. El socio conecta y desvincula él mismo sus propios dominios de tienda; la pestaña Dominio muestra sus registros DNS.',
      },
    },
    region: {
      whole_country: 'Todo el país',
    },
    shop_domains: {
      primary: 'Principal',
      platform_default: 'Predeterminado de la plataforma',
      empty: 'Aún no hay ningún dominio de tienda vinculado',
    },
    statuses: {
      invited: 'Invitado',
      active: 'Activo',
      suspended: 'Suspendido',
    },
    custody: {
      label: 'Procesamiento de pagos',
      not_configured: 'Aún no configurado',
      provider: 'Pasarela propia del socio',
      platform: 'FoodAmigos procesa los pagos',
      bank_account: {
        set: 'Cuenta bancaria: {{label}} ({{status}})',
        missing: 'Aún no hay cuenta bancaria. El socio la introduce en Facturación de socios.',
        statuses: {
          active: 'activa',
          pending_verification: 'en verificación',
          action_needed: 'acción necesaria',
          errored: 'pago fallido',
          missing: 'falta',
        },
      },
      hint: 'Se decide mediante la configuración de pagos en la pestaña Pagos y se bloquea al guardar un método. Con el procesamiento de FoodAmigos, la parte de ingresos del socio se paga mensualmente.',
      kyc: {
        label: 'Cuenta de pagos',
        missing: 'Aún no creada',
        incomplete: 'Verificación incompleta',
        complete: 'Lista para pagos',
        currently_due: 'Stripe todavía necesita: {{fields}}',
        send_link: 'Enviar enlace de incorporación',
        link_copied:
          'Enlace de incorporación copiado al portapapeles; reenvíalo al partner. Es de un solo uso y caduca.',
        link_ready: 'Enlace de incorporación: reenvíalo al partner (un solo uso, caduca)',
        link_failed: 'No se pudo crear el enlace de incorporación.',
      },
    },
    suspend_confirm: {
      title: '¿Suspender este partner?',
      description:
        'Todos los miembros del equipo del partner serán desactivados y sus sesiones revocadas. Sus restaurantes permanecerán activos.',
    },
  },
  branding: {
    read_only_notice: 'Solo lectura. Haz clic en Editar para cambiar algún valor.',
    editing_notice: 'Editando — los cambios son visibles en las superficies de marca blanca del partner.',
    upload: 'Subir logo',
    logo: {
      label: 'Logo',
      hint: 'Se muestra en las superficies de marca blanca del partner.',
    },
    circle_logo: {
      label: 'Favicon / logo circular',
      hint: 'Logo cuadrado usado como favicon y avatar. Opcional — se puede eliminar.',
    },
    splash_image: {
      label: 'Imagen de inicio de sesión',
      hint: 'Ocupa la mitad izquierda de la página de inicio de sesión de marca blanca del partner de extremo a extremo (recorte tipo cover). Recomendado: composición vertical, mínimo 1200×1200px. Opcional — se puede eliminar.',
    },
    footer_note: 'Más opciones de marca (colores secundarios) próximamente.',
  },
  revenue_split: {
    title: 'Reparto de ingresos',
    description:
      'Define la parte del partner en cada tarifa que FoodAmigos cobra en los pedidos de sus restaurantes. Por defecto 0% — FoodAmigos retiene la tarifa completa hasta que se conceda una parte. Se paga en cada ciclo de facturación.',
    manage_on_fees: 'Gestionar en la pestaña Tarifas',
    split: 'Partner {{partner}}% · FoodAmigos {{platform}}%',
    rows: {
      processing: 'Tarifas de procesamiento',
      gift_card: 'Tarifa de tarjeta regalo',
      delivery: 'Tarifas de entrega',
      service_fee: 'Tarifa de servicio',
    },
    notes: {
      service_fee:
        'El importe cobrado a los comensales se configura en Controles de tarifa de servicio, en la pestaña Tarifas.',
    },
  },
  service_fee_controls: {
    title: 'Controles de tarifa de servicio',
    description: 'Lo que el partner cobra a sus comensales como tarifa de servicio sobre el pedido.',
    zero_percentage_warning:
      'Un porcentaje del 0% no desactiva la tarifa de servicio: las tarifas calculadas por debajo del importe mínimo se redondean al alza, por lo que cada pedido sigue siendo cobrado al menos el mínimo.',
  },
  hard_limits: {
    title: 'Límites máximos',
    description:
      'Techos de FoodAmigos aplicados al guardar y en el pago. Ninguna tarifa de servicio de este partner — incluidas las anulaciones por restaurante — puede superar estos valores.',
    max_percentage: {
      label: 'Tarifa de servicio máxima %',
      help: 'La tarifa de servicio del partner no puede superar este valor. Límite de plataforma: 5%.',
    },
    min_amount: {
      label: 'Importe mínimo de tarifa de servicio',
      help: 'Los mínimos por restaurante no pueden ser inferiores a este importe.',
    },
    max_amount: {
      label: 'Importe máximo de tarifa de servicio',
      help: 'Tope absoluto de la tarifa de servicio fija, independientemente del porcentaje.',
    },
  },
  form: {
    charges_service_fee_on_site: {
      label: 'Cobrar el cargo por servicio en los pedidos en mesa',
      description:
        'Valor predeterminado para los restaurantes de este partner; cada uno puede definir el suyo. Desactivado: los pedidos en mesa no pagan cargo por servicio.',
    },
    is_service_fee_change_allowed: {
      label: 'Permitir cambiar la tarifa de servicio por restaurante',
      description: 'Permite que los restaurantes individuales del partner usen una tarifa de servicio diferente.',
    },
    service_fee_platform_share: {
      label: 'Parte de Foodamigos en la tarifa de servicio',
    },
    recommended: 'Recomendado: {{value}}',
    service_fee_percentage: {
      label: 'Porcentaje de tarifa de servicio predeterminado',
      help: 'Aplicado a cada restaurante del partner salvo que se anule.',
    },
    min_service_fee_amount: {
      label: 'Importe mínimo de tarifa predeterminado',
      help: 'Mínimo predeterminado por pedido — las tarifas calculadas por debajo se redondean al alza. Los restaurantes pueden establecer el suyo dentro de los límites de FoodAmigos.',
    },
    max_service_fee_amount: {
      label: 'Importe máximo de tarifa predeterminado',
      help: 'Tope predeterminado por pedido — los restaurantes pueden establecer el suyo dentro de los límites de FoodAmigos.',
    },
    primary_color: {
      label: 'Color de marca principal',
    },
    dashboard_subdomain: {
      label: 'Slug de acceso del socio',
      hint: 'Slug en minúsculas — identifica la marca del socio en su enlace de acceso de equipo (?partner=…).',
      placeholder: 'partner-name',
    },
    login_url: {
      label: 'Enlace de acceso del equipo',
      hint: 'El enlace que usa el equipo del socio para acceder a su página de inicio de sesión con marca.',
    },
    file: {
      label: 'Imagen',
    },
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'No se pudieron cargar los ajustes.',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
    logo_uploaded: 'Logo subido',
    logo_upload_failed: 'Error al subir el logo',
    logo_removed: 'Logo eliminado',
    logo_remove_failed: 'Error al eliminar el logo',
    file_too_large: 'El archivo es demasiado grande. El tamaño máximo es {{max}} MB.',
    image_too_narrow: 'La imagen de inicio de sesión debe tener al menos {{min}}px de ancho.',
  },
  notification_channels: {
    master_locked:
      'El partner maestro envía a todos los restaurantes de la plataforma, por lo que sus canales no se pueden cambiar aquí.',
    unavailable: 'Los canales de notificación aún no están disponibles en este backend.',
    notice:
      'Ajuste interno. Un partner sin cuenta propia de Twilio debe permanecer solo con email: de lo contrario, todos los SMS, mensajes de WhatsApp y llamadas de voz saldrían desde la cuenta de Twilio de FoodAmigos.',
    forbidden: 'Solo los superadministradores pueden cambiar los canales de notificación.',
    columns: {
      channel: 'Canal',
      status: 'Habilitado',
    },
    channels: {
      email: {
        name: 'Email',
        description: 'Siempre activo, para que el partner y sus restaurantes puedan ser contactados en todo momento.',
      },
      sms: {
        name: 'SMS',
        description: 'Actualizaciones de pedidos y códigos de acceso a los clientes por mensaje de texto.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Alertas a los dueños de restaurantes y códigos de acceso a los clientes por WhatsApp.',
      },
      voice_call: {
        name: 'Llamadas de voz',
        description: 'Llamadas de recordatorio para pedidos pendientes y contestador telefónico.',
      },
      push: {
        name: 'Notificaciones push',
        description:
          'Notificaciones push a los clientes y a la app del panel del propietario. Las alertas de la tablet del personal no se ven afectadas.',
      },
    },
    toasts: {
      load_error: 'No se pudieron cargar los canales de notificación.',
      error: 'No se pudieron guardar los canales de notificación.',
      saved: 'Canales de notificación guardados.',
    },
  },
  feature_flags: {
    internal_notice:
      'Configuración exclusiva de FoodAmigos. No visible para el socio. Los cambios tienen efecto inmediato.',
    read_only:
      'Solo lectura — cambiar la facturación de restaurantes requiere un despliegue coordinado, no un interruptor. Hable con ingeniería.',
    forbidden: 'Solo los superadministradores pueden gestionar los indicadores de funcionalidad del socio.',
    columns: {
      feature: 'Función',
      status: 'Estado',
    },
    flags: {
      external_printer: {
        name: 'Impresora de recibos externa',
        description:
          'El valor predeterminado para los restaurantes que este socio incorpore a partir de ahora: cada nuevo restaurante comienza con la posibilidad de conectar una impresora de recibos de red a la app del terminal de pedidos. Los restaurantes existentes conservan lo que indique su propia pestaña de Feature Flags, y cada restaurante puede seguir cambiándose individualmente allí.',
      },
      plg_onboarding: {
        name: 'Incorporación de autoservicio (PLG)',
        description:
          'Onboarding de autoservicio para partners: ofrece a este partner la página guiada Nuevo restaurante y el asistente de onboarding en lugar del modal clásico Añadir empresa y del stepper Primeros pasos, oculta las superficies exclusivas de FoodAmigos y las aún no aplicables para el partner y sus restaurantes, y bloquea el primer lanzamiento hasta acordar una fecha. Activado para cada nuevo partner.',
      },
      issue_end_customer_receipts: {
        name: 'Facturas para clientes finales',
        description:
          'Permite a los clientes solicitar una factura al pagar y recibirla por email. Desactivado para nuevos socios; las normas internacionales de formato de factura hacen que sea costoso de admitir.',
      },
      merchant_billing: {
        name: 'Facturación de restaurantes',
        description:
          'Factura los restaurantes del socio a través de la plataforma. Desactivado significa que liquidan fuera de ella.',
      },
      cuisine_backfill: {
        name: 'Relleno de tipo de cocina',
        description: 'Permite ejecutar el relleno automático de tipo de cocina para los restaurantes de este socio.',
      },
      image_backfill: {
        name: 'Relleno de imágenes',
        description: 'Permite ejecutar el relleno automático de imágenes de menú para los restaurantes de este socio.',
      },
      auto_image_generation: {
        name: 'Generación automática de imágenes',
        description: 'Genera imágenes de menú bajo demanda para los restaurantes de este socio.',
      },
      provider_billing: {
        name: 'Facturación del socio por Foodamigos',
        description:
          'Incluye a este socio en la facturación de Foodamigos. Desactivado significa que el socio se factura fuera de la plataforma. También activa PayPal (directo) para los restaurantes de este socio, con la comisión de servicio cobrada en él.',
      },
      partner_custom_dashboard_domain: {
        name: 'Dominio propio del panel',
        description:
          'Permite que este partner conecte un dominio propio para el panel, de modo que su equipo y restaurantes inicien sesión bajo la dirección del partner. Activarlo o desactivarlo mueve todos los enlaces del panel que la plataforma envía para este partner.',
      },
      partner_custom_shop_domain: {
        name: 'Dominio de tienda propio',
        description:
          'Permite a este partner conectar un dominio propio para las tiendas online de sus restaurantes, en el que cada restaurante recibe su propia dirección. Actívalo partner por partner: cambia la dirección que usan los clientes.',
      },
      partner_legal_documents: {
        name: 'Documentos legales del partner',
        description:
          'Genera el aviso legal, la política de privacidad y los términos para los locales de este partner a partir de los datos legales propios de cada restaurante. Si está desactivado, o mientras los datos de un restaurante estén incompletos, los locales muestran los documentos estándar de la plataforma.',
      },
    },
    toasts: {
      load_error: 'Error al cargar los indicadores de funcionalidad',
      error: 'Error al cambiar el indicador de funcionalidad',
      enabled: 'Función habilitada',
      disabled: 'Función deshabilitada',
    },
  },
};
